import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'formatRRP',
})
export class FormatRrpPipe implements PipeTransform {
  constructor(public currencyPipe: CurrencyPipe) {}
  transform(rrpValue: number, rrpFlag: boolean): string {
    const decimal = parseInt(
      ((rrpValue - Math.floor(rrpValue)) * 100).toFixed(2),
      10
    );

    return rrpFlag && rrpValue > 1
      ? decimal === 0
        ? this.currencyPipe.transform(rrpValue, 'GBP', 'symbol', '0.0')
        : this.currencyPipe.transform(rrpValue, 'GBP', 'symbol', '0.2')
      : 'Not available';
  }
}
